import React, { useEffect, useState } from 'react';
import Button from 'xpi-black-ui/Base/Button';
import { convertToCurrency } from 'xpi-black-ui/Utils/helpers';
import { useSelector } from 'react-redux';
import { Row } from 'xpi-black-ui/Base/Grid';
import { Text } from 'xpi-black-ui/Base/Typography';
import waConfig from 'utils/waConfig';
import { SomaButton } from '@soma/react';
import useProposal from 'store/Proposals/state';
import { useCMSModal } from '../../../../../hooks/useCMSModal';
import UploadClients from '../UploadClients';
import { Footer } from './styles';
import { DefaultProps, Props } from './shape';

const FooterWrapper = ({
  clients,
  onSendProposal,
  onSendConfirmProposal,
  onVerifyRiskClients,
  sendingProposal,
  verifyHasClientValid,
  totalCommission,
  loadClientsFromExcel,
  disabledBasketClients,
  isRubiYield,
}) => {
  const { currentProposal, setCurrentProposal, setIsSendingPush } = useProposal();
  const { product } = useSelector(state => state.Product);
  const [hasToVerifyRisk, setHasToVerifyRisk] = useState(false);
  const [disabledSendPush, setDisabledSendPush] = useState(true);
  const cmsModal = useCMSModal();
  const getClientsToVerifyRisk = () => clients?.filter(client => client.isSelected && client.quantity > 0 && !client.riskValidated);

  const verifyHasRiskClient = () => {
    const clientsSelected = getClientsToVerifyRisk();
    const hastToVerify = clientsSelected?.length > 0 && verifyHasClientValid(clientsSelected);
    setHasToVerifyRisk(hastToVerify);
  };

  useEffect(() => {
    if (clients?.length > 0 && !isRubiYield) {
      verifyHasRiskClient();
    }
  }, [clients]);

  useEffect(() => {
    if (clients?.length > 0) {
      const clientsSelected = clients?.filter(client => client.isSelected && client.quantity > 0);
      const allClientsIsAvailable = verifyHasClientValid(clientsSelected);
      const disabled = sendingProposal || !allClientsIsAvailable || hasToVerifyRisk;
      setDisabledSendPush(disabled);
    }
  }, [clients, hasToVerifyRisk]);

  return (
    <Footer>
      <UploadClients
        loadClientsFromExcel={loadClientsFromExcel}
        showMessageDisabledButton={disabledBasketClients}
        disableButtons={sendingProposal || disabledBasketClients}
      />
      <Row>
        <Row>
          {totalCommission > 0
            && (
              <>
                <Text bigger>Comissão Total Estimada</Text>
                <Text bigger>{convertToCurrency(totalCommission)}</Text>
              </>
            )
          }
        </Row>
        {!isRubiYield && (
          <Button
            disabled={!hasToVerifyRisk}
            style={{ marginRight: '24px' }}
            data-wa={waConfig.event.acquisition.verifyRisk}
            onClick={() => onVerifyRiskClients(getClientsToVerifyRisk())}
          >
            Verificar risco da carteira
          </Button>
        )}
        <Button
          onClick={
            product.estrutura === 'POP'
              || product.estrutura === 'POP Plus'
              || product.estrutura === 'POP Plus Sob Custodia'
              || product.estrutura === 'POP Sob Custodia' ? () => {
                setIsSendingPush(true);
                onSendConfirmProposal();
                cmsModal.openInStructurePopModal();
              } : onSendProposal}
          data-wa={waConfig.event.acquisition.buttonSendPush}
          disabled={disabledSendPush}
        >
          Enviar push
        </Button>
      </Row>
    </Footer>
  );
};

FooterWrapper.defaultProps = DefaultProps;
FooterWrapper.propTypes = Props;

export default FooterWrapper;
